'use client';
import { createTheme } from '@mui/material/styles';
import tokenData from '../design-tokens/base-tokens.json';
import typography from './components/typography';
import { spacing } from './components/spacing';
import palette from './components/palette';
import { MuiButton, MuiIconButton, MuiButtonGroup } from './components/buttons';
import MuiCheckbox from './components/checkbox';
import MuiRadio from './components/radio';
import MuiSwitch from './components/switch';
import { MuiSvgIcon, MuiIcon } from './components/icons';
import { MuiOutlinedInput, MuiTextField, MuiAutocomplete, MuiSelect, MuiNativeSelect } from './components/fields';
import MuiChip from './components/chip';
import { MuiInputLabel, MuiFormLabel, MuiFormControlLabel, MuiFormHelperText } from './components/labels';
import { MuiPickersCalendarHeader, MuiPickersArrowSwitcher, MuiDatePicker, MuiDatePickerToolbar, MuiDateTimePicker, MuiYearPicker, MuiDateRangePickerDay, MuiPickersLayout, MuiDayCalendar, MuiMultiInputDateRangeField, MuiPickersDay, MuiYearCalendar, MuiPickersYear, MuiPickersToolbar, MuiPickersMonth, MuiMultiSectionDigitalClock } from './components/datepicker-v6';
import { MuiTabs, MuiTab } from './components/tabs';
import { MuiModal, MuiDialog, MuiDialogActions, MuiBackdrop } from './components/dialogs';
import { MuiMenu, MuiMenuItem } from './components/menu';
import { MuiList, MuiListItem, MuiListItemButton, MuiListItemText, MuiListSubheader } from './components/list';
import MuiDataGrid from './components/datagrid';
import { MuiTable, MuiTableContainer, MuiTableHead, MuiTableCell, MuiTableSortLabel, MuiTableBody, MuiTablePagination } from './components/table';
import { MuiAccordion, MuiAccordionDetails, MuiAccordionSummary, MuiAlert, MuiBadge, MuiBreadcrumbs, MuiCircularProgress, MuiDivider, MuiFormControl, MuiLinearProgress, MuiLink, MuiPagination, MuiPaginationItem, MuiTooltip } from './components/misc';
import { MuiStep, MuiStepper, MuiMobileStepper, MuiStepButton } from './components/stepper';
import { MuiSnackbar, MuiSnackbarContent } from './components/snackbar';
import { MuiToggleButton, MuiToggleButtonGroup } from './components/togglebutton';
import { MuiCard, MuiCardActions, MuiCardMedia, MuiCardHeader, MuiCardActionArea, MuiCardContent } from './components/card';
import { MuiAvatar } from './components/avatar';
import { MuiAppBar } from './components/appbar';
import { MuiDrawer } from './components/drawer';
import { MuiSlider } from './components/slider';
import { MuiFab } from './components/fab';
let theme = createTheme({
    typography,
    palette,
    shadows: [
        'none',
        tokenData.tokens.elevations[1],
        tokenData.tokens.elevations[2],
        tokenData.tokens.elevations[3],
        tokenData.tokens.elevations[4],
        tokenData.tokens.elevations[5],
        tokenData.tokens.elevations[6],
        tokenData.tokens.elevations[7],
        tokenData.tokens.elevations[8],
        tokenData.tokens.elevations[9],
        tokenData.tokens.elevations[10],
        tokenData.tokens.elevations[11],
        tokenData.tokens.elevations[12],
        tokenData.tokens.elevations[13],
        tokenData.tokens.elevations[14],
        tokenData.tokens.elevations[15],
        tokenData.tokens.elevations[16],
        tokenData.tokens.elevations[17],
        tokenData.tokens.elevations[18],
        tokenData.tokens.elevations[19],
        tokenData.tokens.elevations[20],
        tokenData.tokens.elevations[21],
        tokenData.tokens.elevations[22],
        tokenData.tokens.elevations[23],
        tokenData.tokens.elevations[24]
    ],
    spacing: spacing
});
export let basicThemeV6 = createTheme(theme, {
    shape: {
        borderRadius: 6
    },
    components: {
        MuiButton,
        MuiIconButton,
        MuiButtonGroup,
        MuiCheckbox,
        MuiRadio,
        MuiSwitch,
        MuiSvgIcon,
        MuiIcon,
        MuiDivider,
        MuiTooltip,
        MuiChip,
        MuiLink,
        MuiAlert,
        MuiTabs,
        MuiTab,
        MuiBackdrop,
        MuiDataGrid,
        MuiTable,
        MuiTableContainer,
        MuiTableHead,
        MuiTableCell,
        MuiOutlinedInput,
        MuiTextField,
        MuiAutocomplete,
        MuiSelect,
        MuiNativeSelect,
        MuiTablePagination,
        MuiTableSortLabel,
        MuiTableBody,
        MuiModal,
        MuiDialog,
        MuiDialogActions,
        MuiInputLabel,
        MuiFormLabel,
        MuiFormControlLabel,
        MuiFormHelperText,
        MuiList,
        MuiListItem,
        MuiListItemButton,
        MuiListItemText,
        MuiMenu,
        MuiMenuItem,
        MuiListSubheader,
        MuiFormControl,
        MuiPagination,
        MuiPaginationItem,
        MuiAccordion,
        MuiAccordionDetails,
        MuiAccordionSummary,
        MuiBadge,
        MuiBreadcrumbs,
        MuiCircularProgress,
        MuiLinearProgress,
        MuiSnackbar,
        MuiSnackbarContent,
        MuiDateTimePicker,
        MuiDatePicker,
        MuiDatePickerToolbar,
        MuiPickersDay,
        MuiPickersCalendarHeader,
        MuiYearPicker,
        MuiYearCalendar,
        MuiPickersYear,
        MuiPickersArrowSwitcher,
        MuiMultiInputDateRangeField,
        MuiDateRangePickerDay,
        // v6 additional styling
        MuiPickersMonth,
        MuiDayCalendar,
        MuiPickersLayout,
        MuiPickersToolbar,
        MuiMultiSectionDigitalClock,
        MuiStepper,
        MuiMobileStepper,
        MuiStepButton,
        MuiStep,
        MuiToggleButton,
        MuiToggleButtonGroup,
        MuiCard,
        MuiCardActions,
        MuiCardMedia,
        MuiCardHeader,
        MuiCardActionArea,
        MuiCardContent,
        MuiAvatar,
        MuiAppBar,
        MuiDrawer,
        MuiSlider,
        MuiFab
    }
});
export default basicThemeV6;
